export default __webpack_public_path__ + "static/media/TiemposFineWeb-Light.d062fb18.woff2";